import React from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from '../_shared/index.js';
import ManageRewardContainer from './container/manageRewardContainer';

export const ManageRewards = () => {
	const currentUser = useSelector((state) => state.user.currentUser);
	if (!currentUser?.company) return <Spinner />;
	return <ManageRewardContainer currentUser={currentUser} />;
};

export default ManageRewards;
